import { PersonOutline } from '@mui/icons-material'
import { Button, Tooltip, Typography } from '@mui/material'
import { ReduxState, ReduxUser } from 'app/redux/ReduxInterfaces'
import sfOauthConfig from 'app/services/sfAuth/sfAuthConfig'
import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { GRANTS_PATH } from '../grants/GrantsConstants'

export const UserProfileButton: React.FC<{ isSmallScreen?: boolean }> = ({ isSmallScreen = false }) => {
  const user = useSelector<ReduxState, ReduxUser>(state => state.user)
  const history = useHistory()

  if (sfOauthConfig.isInternal === true) {
    return (
      <div className='topbar-button-box'>
        {isSmallScreen
          ? (
            <Tooltip title={user.displayName}>
              <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
            </Tooltip>
            )
          : (
            <>
              <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
              <Typography sx={{ color: 'black' }}>
                {user.displayName}
              </Typography>
            </>
            )}
      </div>
    )
  }

  return (
    <div className='topbar-button-box'>
      <Button
        sx={{ padding: 0 }}
        variant='text'
        onClick={e => {
          history.push(GRANTS_PATH.USER_PROFILE)
        }}
      >
        {isSmallScreen
          ? (
            <Tooltip title={user.displayName}>
              <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
            </Tooltip>
            )
          : (
            <>
              <PersonOutline sx={{ color: 'primary.main', marginRight: '8px', fontSize: 24 }} />
              <Typography sx={{ color: 'black' }}>
                {user.displayName}
              </Typography>
            </>
            )}
      </Button>
    </div>
  )
}
